/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AlbHttpClient } from 'ng/modules/http/service/alb-http-client.service';
import { ISystemInfo } from './system-info.state';

const SYSTEM_INFO_URL = '/api/system-info';

/**
 * @desc Service for fetching System Info data.
 * @author Zhiqian Liu
 */
@Injectable({
    providedIn: 'root',
})
export class SystemInfoService {
    constructor(private readonly http: AlbHttpClient) {}

    public loadSystemInfo(): Observable<ISystemInfo> {
        return this.http.get<ISystemInfo>(SYSTEM_INFO_URL);
    }
}
